var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBankGesloten(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 486.21 257.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fef7e3;\n      }\n\n      .cls-2 {\n        fill: #e8d8bb;\n      }\n\n      .cls-3 {\n        fill: #d5d1c1;\n      }\n\n      .cls-4 {\n        fill: #37474f;\n      }\n\n      .cls-5 {\n        fill: #455a64;\n      }\n\n      .cls-6 {\n        fill: #a6a6a6;\n      }\n\n      .cls-7 {\n        fill: #b1b1b1;\n        opacity: .62;\n      }\n\n      .cls-8 {\n        fill: #7a7161;\n      }\n\n      .cls-9 {\n        fill: #e7d7ba;\n      }\n\n      .cls-10 {\n        fill: #767676;\n      }\n\n      .cls-11 {\n        fill: #ebebeb;\n      }\n\n      .cls-12 {\n        opacity: .1;\n      }\n\n      .cls-13 {\n        fill: #9c927f;\n      }\n\n      .cls-14 {\n        fill: #263238;\n      }\n\n      .cls-15 {\n        fill: url(#linear-gradient);\n        filter: url(#drop-shadow-1);\n        stroke: #fff;\n        stroke-miterlimit: 10;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 416.47,
    y1: 66.1,
    x2: 373.56,
    y2: 57.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9d9d9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#c4c4c4"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-1",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m70.6,253.07s-2.12-9.81-6.34-11.4-6.8,2.92-6.8,2.92c0,0-1-9.44-7.01-12.25-6.02-2.82-10.49,2.96-10.49,2.96,0,0-4.6-11.97-12.82-11.97s-12.35,17.51-12.35,17.51c0,0-4.85-5.22-9.81-2.27C.01,241.5,0,253.07,0,253.07h70.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m486.21,252.25h-32.99s.07-4.91,3.31-6.21c1.81-.79,3.92-.28,5.17,1.24,0,0,1.32-9.04,7.37-9.04s8.94,7.79,8.94,7.79c1.05-1.53,2.91-2.28,4.73-1.92,3.32.44,3.47,8.13,3.47,8.13Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 55.38,
    y: 72.06,
    width: 368.78,
    height: 169.92
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 72.87,
    y: 148.08,
    width: 81.79,
    height: 59.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 75.19,
    y: 150.4,
    width: 77.14,
    height: 54.92
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "152.33 189.78 152.33 200.96 147.97 205.32 136.78 205.32 152.33 189.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "122.66 150.4 75.19 197.87 75.19 186.68 111.48 150.4 122.66 150.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "129.63 150.4 75.19 204.84 75.19 202.47 127.27 150.4 129.63 150.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "152.33 171.79 152.33 174.14 121.15 205.32 118.79 205.32 152.33 171.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "152.33 205.22 152.33 205.32 152.23 205.32 152.33 205.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "101.78 150.4 75.19 176.99 75.19 172.36 97.15 150.4 101.78 150.4"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 321.53,
    y: 148.08,
    width: 81.79,
    height: 59.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 323.85,
    y: 150.4,
    width: 77.14,
    height: 54.92
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "400.99 189.78 400.99 200.96 396.63 205.32 385.44 205.32 400.99 189.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "371.32 150.4 323.85 197.87 323.85 186.68 360.14 150.4 371.32 150.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "378.29 150.4 323.85 204.84 323.85 202.47 375.93 150.4 378.29 150.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "400.99 171.79 400.99 174.14 369.81 205.32 367.45 205.32 400.99 171.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "400.99 205.22 400.99 205.32 400.89 205.32 400.99 205.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "350.44 150.4 323.85 176.99 323.85 172.36 345.81 150.4 350.44 150.4"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 10.31,
    y: 70.37,
    width: 460.68,
    height: 7.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 10.31,
    y: 243.44,
    width: 460.68,
    height: 13.76
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 22.31,
    y: 229.69,
    width: 436.68,
    height: 13.76
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "26.33 70.83 240.65 0 454.97 70.83 26.33 70.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "102.87 58.59 240.65 13.06 378.44 58.59 102.87 58.59"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 208,
    y: 150.84,
    width: 33.62,
    height: 78.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 213,
    y: 155.96,
    width: 23.62,
    height: 53
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "236.62 155.96 236.62 160.62 213 184.24 213 173.05 230.08 155.96 236.62 155.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "236.62 180.37 236.62 191.55 219.25 208.96 213 208.96 213 204.02 236.62 180.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "236.62 175.46 236.62 177.82 213 201.48 213 199.11 236.62 175.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "227.71 155.96 213 170.67 213 166.04 223.08 155.96 227.71 155.96"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 238.12,
    y: 191.62,
    width: 1.63,
    height: 8.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 213,
    y: 194.16,
    width: 23.62,
    height: 3.76
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 241.92,
    y: 150.84,
    width: 33.62,
    height: 78.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 246.92,
    y: 155.96,
    width: 23.62,
    height: 53
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "270.54 155.96 270.54 160.62 246.92 184.24 246.92 173.05 264 155.96 270.54 155.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "270.54 180.37 270.54 191.55 253.17 208.96 246.92 208.96 246.92 204.02 270.54 180.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "270.54 175.46 270.54 177.82 246.92 201.48 246.92 199.11 270.54 175.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "261.63 155.96 246.92 170.67 246.92 166.04 257 155.96 261.63 155.96"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 243.79,
    y: 191.62,
    width: 1.63,
    height: 8.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 246.92,
    y: 194.16,
    width: 23.62,
    height: 3.76
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 88.42,
    y: 108.76,
    width: 9.93,
    height: 4.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 93.96,
    y: 114.05,
    width: 9.93,
    height: 4.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 251,
    y: 130.11,
    width: 9.93,
    height: 4.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 256.54,
    y: 135.4,
    width: 9.93,
    height: 4.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 370.55,
    y: 213.93,
    width: 9.93,
    height: 4.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 376.09,
    y: 219.22,
    width: 9.93,
    height: 4.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 355.73,
    y: 108.76,
    width: 9.93,
    height: 4.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 350.19,
    y: 114.05,
    width: 9.93,
    height: 4.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 177.82,
    y: 122.82,
    width: 9.93,
    height: 4.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 172.28,
    y: 128.11,
    width: 9.93,
    height: 4.2
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 101.7,
    y: 132.76,
    width: 9.93,
    height: 4.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 98.93,
    y: 211.83,
    width: 9.93,
    height: 4.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 235.87,
    y: 104,
    width: 9.93,
    height: 4.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 283.78,
    y: 114.05,
    width: 9.93,
    height: 4.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 388.25,
    y: 132.76,
    width: 9.93,
    height: 4.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 42.6,
    y: 86.94,
    width: 47.82,
    height: 13.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 33.73,
    y: 216.67,
    width: 65.56,
    height: 13.02
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "88.95 216.67 44.06 216.67 44.67 203.65 88.34 203.65 88.95 216.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "88.34 203.65 44.67 203.65 49.57 99.95 83.44 99.95 88.34 203.65"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 136.24,
    y: 86.94,
    width: 47.82,
    height: 13.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 127.37,
    y: 216.67,
    width: 65.56,
    height: 13.02
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "182.6 216.67 137.71 216.67 138.32 203.65 181.99 203.65 182.6 216.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "181.99 203.65 138.32 203.65 143.22 99.95 177.09 99.95 181.99 203.65"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 297.62,
    y: 86.94,
    width: 47.82,
    height: 13.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 288.75,
    y: 216.67,
    width: 65.56,
    height: 13.02
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "343.97 216.67 299.08 216.67 299.69 203.65 343.36 203.65 343.97 216.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "343.36 203.65 299.69 203.65 304.59 99.95 338.46 99.95 343.36 203.65"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 389.13,
    y: 86.94,
    width: 47.82,
    height: 13.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 380.26,
    y: 216.67,
    width: 65.56,
    height: 13.02
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "435.49 216.67 390.6 216.67 391.21 203.65 434.88 203.65 435.49 216.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "434.88 203.65 391.21 203.65 396.11 99.95 429.98 99.95 434.88 203.65"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m213.31,48.29c0,3.81-3.14,5.62-7.87,5.62h-11.31v-21.15h10.95c4.71,0,7.67,1.69,7.67,5.62,0,2.66-1.16,4.52-3.23,4.95,2.14.2,3.79,2.16,3.79,4.95Zm-8.52-6.95c1.25,0,2.17-.94,2.17-2.37s-.92-2.37-2.37-2.37h-4.5v4.74h4.7Zm.15,8.61c1.48,0,2.36-.89,2.36-2.37s-.97-2.37-2.34-2.37h-4.86v4.74h4.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m229.89,53.91l-1.16-3.87h-7.4l-1.16,3.87h-6.16l7.02-21.15h7.94l7.05,21.15h-6.13Zm-2.42-8.05l-2.45-8.14-2.45,8.14h4.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m258.01,32.76v21.15h-6.37l-7.58-11.8v11.8h-5.97v-21.15h6.37l7.58,11.81v-11.81h5.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m267.53,41.81l6.57-9.05h6.9l-7.96,10.57,8.07,10.57h-7.01l-6.57-9.05v9.05h-5.97v-21.15h5.97v9.05Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m212.31,47.29c0,3.81-3.14,5.62-7.87,5.62h-11.31v-21.15h10.95c4.71,0,7.67,1.69,7.67,5.62,0,2.66-1.16,4.52-3.23,4.95,2.14.2,3.79,2.16,3.79,4.95Zm-8.52-6.95c1.25,0,2.17-.94,2.17-2.37s-.92-2.37-2.37-2.37h-4.5v4.74h4.7Zm.15,8.61c1.48,0,2.36-.89,2.36-2.37s-.97-2.37-2.34-2.37h-4.86v4.74h4.85Zm24.95,3.96l-1.16-3.87h-7.4l-1.16,3.87h-6.16l7.02-21.15h7.94l7.05,21.15h-6.13Zm-2.42-8.05l-2.45-8.14-2.45,8.14h4.89Zm30.53-13.1v21.15h-6.37l-7.58-11.8v11.8h-5.97v-21.15h6.37l7.58,11.81v-11.81h5.97Zm9.52,9.05l6.57-9.05h6.9l-7.96,10.57,8.07,10.57h-7.01l-6.57-9.05v9.05h-5.97v-21.15h5.97v9.05Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 22.31,
    y: 78.33,
    width: 436.68,
    height: 9.35
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m486.21,252.25s-.14-7.69-3.47-8.13c-1.82-.37-3.68.39-4.73,1.92,0,0-2.9-7.79-8.94-7.79-3.33,0-5.22,2.74-6.25,5.2h-3.83v-13.76h-13.17v-13.02h-21.66s11.33,0,11.33,0l-.61-13.02-4.9-103.69h6.97v-12.28h22.04v-9.35h-34.83v-.12h46.83v-7.84h-17.4L240.65,0,27.71,70.37H10.31v7.84h45.07v.12H22.31v9.35h20.29v12.28h6.98l-4.9,103.69-.61,13.02h11.32s-21.66,0-21.66,0v9.4c-1.82-1.59-4.03-2.75-6.58-2.75-8.22,0-12.35,17.51-12.35,17.51,0,0-4.85-5.22-9.81-2.27C.01,241.5,0,253.07,0,253.07h10.31v4.13h460.68v-4.95h15.22Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m414.31,54.86l.4-2.58c.1-.71.16-1.41.19-2.11l.05-.49h-.05c.11-9.03-6.37-16.87-15.49-18.28-9.11-1.41-17.66,4.1-20.27,12.74h-.04s-.1.47-.1.47c-.2.68-.36,1.37-.46,2.08l-.4,2.58c-2.86-.44-5.53,1.53-5.97,4.37l-4.39,28.43c-.44,2.84,1.52,5.52,4.37,5.96l36.18,5.59c2.86.45,5.52-1.53,5.96-4.36l4.39-28.43c.44-2.85-1.52-5.52-4.36-5.97Zm-15.08,16.78c-.3,1.21-1.51,2.62-4.01,3.6-.27.11-.46.38-.45.68.17,2.73.26,4.6-.09,7.3-.05.37-.41.63-.78.58l-5.41-.84c-.38-.06-.63-.42-.58-.78.47-2.69,1.07-4.47,2.04-7.04.09-.26.03-.56-.18-.75-1.88-1.73-2.51-3.35-2.35-4.56.94-7.17,13.5-5.06,11.81,1.82Zm7.72-20.56l-.4,2.58-20.67-3.19.4-2.58c.1-.72.32-1.41.58-2.06.35-.93.83-1.77,1.39-2.54.18-.23.33-.46.53-.68.19-.22.4-.42.62-.64.26-.24.51-.48.8-.69.19-.16.4-.29.61-.43.33-.24.68-.45,1.05-.64.2-.09.4-.2.6-.29.4-.18.82-.31,1.23-.44.2-.05.39-.13.59-.18.45-.09.91-.15,1.38-.2.19-.02.38-.05.56-.06.66-.03,1.34,0,2.01.1.71.1,1.4.29,2.05.53,3.25,1.2,5.67,3.97,6.51,7.27.16.65.26,1.32.3,2.01.02.69-.01,1.41-.13,2.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m399.22,71.64c-.3,1.21-1.51,2.62-4.01,3.6-.27.11-.46.38-.45.68.17,2.73.26,4.6-.09,7.3-.05.37-.41.63-.78.58l-5.41-.84c-.38-.06-.63-.42-.58-.78.47-2.69,1.07-4.47,2.04-7.04.09-.26.03-.56-.18-.75-1.88-1.73-2.51-3.35-2.35-4.56.94-7.17,13.5-5.06,11.81,1.82Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankGesloten);
export default __webpack_public_path__ + "static/media/bank-gesloten.c186e8dab52679bd060019fb20563641.svg";
export { ForwardRef as ReactComponent };